import { useRef } from 'react';

import { getCredentials } from '@identity/composition';
import { useIdentityFlow } from '@identity/presentation/context';

/**
 * The account this flow is about, read from the credential source its flow authorizes with.
 *
 * It is read once per mount, into a ref, because it is part of the cache key of the status query and
 * the cookie it comes from is deleted while that query is still mounted — on the last screen of the
 * invitation flow, and on logout. A key that changed halfway would read a different entry.
 *
 * It is `null` when there is no credential, which the pages already handle.
 */
export const useIdentityUserId = (): string | null => {
  const flow = useIdentityFlow();
  const userIdRef = useRef<string | null | undefined>(undefined);

  if (userIdRef.current === undefined) {
    userIdRef.current = getCredentials(flow).readUserId();
  }

  return userIdRef.current;
};
